import { render, staticRenderFns } from "./Tehtavat.vue?vue&type=template&id=d13d007a&scoped=true"
import script from "./Tehtavat.vue?vue&type=script&lang=js"
export * from "./Tehtavat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d007a",
  null
  
)

export default component.exports